import { render, staticRenderFns } from "./ShippingDetails.vue?vue&type=template&id=2f651fce&"
import script from "./ShippingDetails.vue?vue&type=script&lang=js&"
export * from "./ShippingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports